var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "106.000000pt",
    height: "108.000000pt",
    viewBox: "0 0 106.000000 108.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,108.000000) scale(0.100000,-0.100000)",
    fill: "#FFF",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M413 1065 c-112 -25 -209 -79 -290 -164 -33 -34 -43 -52 -43 -78 0 -19 -12 -57 -26 -85 -38 -74 -54 -166 -54 -311 0 -117 2 -128 18 -125 15 3 18 22 22 168 5 146 9 172 31 225 25 59 26 60 68 62 37 2 49 9 93 53 96 97 237 145 364 121 89 -16 154 -51 221 -117 54 -52 65 -58 109 -55 16 2 26 -9 42 -47 36 -82 42 -130 42 -334 l0 -196 -26 -32 c-45 -53 -70 -60 -211 -60 -123 0 -129 1 -138 23 -9 20 -18 22 -98 25 -57 2 -94 -1 -103 -9 -8 -7 -14 -31 -14 -60 0 -61 13 -69 110 -69 74 0 110 11 110 34 0 11 31 15 143 17 121 4 147 7 177 25 81 47 96 108 87 363 -6 170 -18 235 -56 314 -12 24 -21 58 -21 76 0 28 -11 44 -63 95 -130 127 -314 180 -494 141z m246 -40 c87 -23 159 -64 222 -125 60 -59 68 -77 47 -98 -21 -21 -35 -14 -92 43 -83 83 -165 118 -286 123 -144 6 -249 -35 -346 -135 -45 -45 -68 -51 -87 -22 -8 13 -4 24 18 50 33 40 114 103 167 130 93 48 251 63 357 34z m-51 -952 l3 -33 -80 0 -81 0 0 28 c0 16 3 32 7 36 4 4 39 5 78 4 l70 -3 3 -32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102 624 c-21 -15 -22 -20 -22 -208 0 -136 3 -195 12 -204 16 -16 160 -16 176 0 9 9 12 68 12 204 0 188 -1 193 -22 208 -14 10 -44 16 -78 16 -34 0 -64 -6 -78 -16z m143 -209 l0 -180 -65 0 -65 0 -3 170 c-1 93 0 175 3 183 3 9 22 12 67 10 l63 -3 0 -180z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M797 633 c-30 -8 -37 -47 -37 -221 0 -213 0 -212 110 -212 68 0 81 3 90 19 6 12 10 95 10 200 0 168 -1 182 -20 201 -16 16 -32 20 -77 19 -32 -1 -66 -3 -76 -6z m133 -218 l0 -186 -62 3 -63 3 -3 183 -2 182 65 0 65 0 0 -185z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg2);
export default __webpack_public_path__ + "static/media/img_2.0df070b219077867a0c3b678689baadf.svg";
export { ForwardRef as ReactComponent };